<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>{{ isFormView ? 'Registrar detalle de servicio' : 'Detalle de servicio' }}</h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        @if (swServiceRequiresOrder && serviceModel.swOrder) {
        <app-custom-button [label]="'Ped.Manual'" [severity]="'primary'" [disabled]="disabledDetail" [width]="'6.5rem'"
          [icon]="'pi pi-user-edit'" (onClick)="openServiceManualOrderSelectionModal('detail')">
        </app-custom-button>
        <app-custom-modal #serviceManualOrderSelection [header]="'Servicio Manual Pedido'" [width]="'80vw'"
          [inputs$]="inputsForServiceManualOrderSelectionModals$" [children]="componentManualOrderSelection"
          (selectedItems)="handleServiceManualOrderSelection($event)" hidden>
        </app-custom-modal>
        } @else {
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
          [width]="'6.5rem'" (onClick)="openArticleSelectionModal()"></app-custom-button>
        <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
          [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
          (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        }
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-service-detail [serviceModel]="serviceModel" [serviceDetailContract]="serviceDetail"
          [defaultStoreIdForBranch]="defaultStoreIdForBranch" (updateListDetail)="getServiceDetailsByService()"
          (isFormView)="getFormView($event)">
        </app-register-service-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getServiceDetailsByService()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>
<!-- Precios C.Costos -->
<app-custom-modal #costCenterPriceRegisterModal [label]="'Precios C.Costos - Captura'"
  [header]="'Precios C.Costos - Captura'" [inputs$]="inputsForRegisterModals$" [width]="'50rem'"
  [children]="componentRegisterModal" hidden (params)="getCostCenterPriceRegister($event.costCenterPriceModel)">
</app-custom-modal>